import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { KmsEnum } from 'src/app/areas/kms/serves/kms-enum';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';

@Component({
  selector: 'app-fields-view',
  templateUrl: './field-view.component.html',
  styleUrls: ['./field-view.component.css']
})
export class FieldsViewComponent implements OnInit {
  @Input() id:string;              // 属性主键id（自增长id）
  @Input() conceptName:string;      // 所属概念名称
  @Input() selectAttr:any;      // 所属概念名称
  formModel:any = {}; // 表单信息
  // 字段类型字典类型字段
  dictionaryField: any = KmsEnum.KGS_FILEID_TYPE_OPTION;
  // 字段类型数据组
  typeDatas = [];
  // 表单控件类型
  formControlTypes = KmsEnum.FORM_CONTROL_TYPES;
  constructor(
    private kmsService: KmsService,
    private dicService: DictionaryService,
    private message: SwMassageBoxService,
  ) { }

  ngOnInit() {
    this.typeDatas = this.dicService.getDictionaryValueOrName(this.dictionaryField);
  }

  ngOnChanges() {
    // 根据主键查询属性信息
    this.kmsService.getOntologyById(this.id).subscribe(
      result => {
        if (result.code == 200) {
          this.formModel = result.data;
          this.formModel.fieldTypeCh = this.getDictionaryName(result.data.fieldType);
          if (this.formModel.dictionryCode == 'Tab') {
            this.formModel.isTab = true;
          } else {
            this.formModel.isTab = false;
          }
        }else{
          this.message.waring(result.msg);
        }
      }
    )
  }

  // 表格字段类型字典值转换为中文
  getDictionaryName(y) {
    if (y) {
        let yDatas: any;
        let datas = [];
        yDatas = y.split(',');
        for (let i = 0; i < this.typeDatas.length; i++) {
            for (let j = 0; j < yDatas.length; j++) {
                if (this.typeDatas[i].id == yDatas[j]) {
                    datas.push(this.typeDatas[i].text)
                }
            }
        }
        if (datas.toString()) {
            return datas.toString();
        }
    }
}
}
